import theme, { DISABLED_OPACITY } from '../../services/theme'
import { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup'

const primary = theme.palette.toggleGroup.primary
const secondary = theme.palette.toggleGroup.secondary

export default {
    root: {
        background: 'transparent !important',
        display: 'flex',
        flexWrap: 'wrap'
    },
    toggleButtonGroup: {
        display: 'flex',
        justifyContent: 'space-between',
        [`& .${toggleButtonGroupClasses.grouped}`]: {
            margin: theme.spacing(0.5),
            border: 0,
            borderRadius: theme.shape.borderRadius,
            [`&.${toggleButtonGroupClasses.disabled}`]: {
                border: 0
            }
        },
        [`&.vertical`]: {
            paddingRight: '8px'
        },
        [`&.primary`]: {
            background: primary.group,
            border: `1px solid ${primary.border}`,
        },
        [`&.secondary`]: {
            background: secondary.group,
            border: `1px solid ${secondary.border}`,
        },
        [`&.disabled`]: {
            opacity: DISABLED_OPACITY
        }
    },
    button: {
        backgroundColor: 'transparent',
        [`&.primary`]: {
            color: primary.unselected.color,
            [`&.selected`]: {
                color: primary.selected.color,
                backgroundColor: primary.selected.background
            },
            [`&:hover`]: {
                color: primary.hover.color,
                backgroundColor: primary.hover.background
            }
        },
        [`&.secondary`]: {
            color: secondary.unselected.color,
            [`&.selected`]: {
                color: secondary.selected.color,
                backgroundColor: secondary.selected.background
            },
            [`&:hover`]: {
                color: secondary.hover.color,
                backgroundColor: secondary.hover.background
            }
        },
        [`&.disabled`]: {
            opacity: DISABLED_OPACITY
        }
    }
}